import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import * as React from 'react';
import { RenderElementProps } from 'slate-react';

import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { MediaProps, MediaType } from '../../../DolEditor/elements/media-constant';
import { withDynamicBlogEditorPluginHydration } from '@doltech/core/lib/hooks/withDolHydrationOnDemand';

const VocabListNews = withDynamicBlogEditorPluginHydration({ canInteract: true })(dynamicEditorComponent(() =>
  import('./components/VocabListNews').then((mod) => mod.VocabListNews),
));

const UploadVocabListNews = (dynamicEditorComponent(() =>
  import('./components/UploadVocabListNews').then((mod) => mod.UploadVocabListNews),
));

export const VocabListNewsPlugin = (options?: MediaProps): SlatePlugin => {
  return {
    renderElement: (renderProps: RenderElementProps) => {
      const { element } = renderProps;
      if (element?.type === MediaType.VOCAB_LIST_NEWS) {
        if (element?.url) {
          return <VocabListNews {...renderProps} {...options} />;
        }
        return <UploadVocabListNews {...renderProps} {...options} />;
      }
      return null;
    },
  };
};
